import * as React from 'react';
import $ from "jquery";
import { Alert, Box, Button, Card, CardContent, CircularProgress, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Stack, Typography } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import Gradient from "javascript-color-gradient";
import { BarChart } from '@mui/x-charts/BarChart';
import { LineChart } from '@mui/x-charts/LineChart';
import Common from '../utilities/common';
import { Apellido } from '../Apellidos/Apellido';

export interface IExtraccionesUltimoMesChartState {
    data: any[];
    month: number;
    loading: boolean;
}

export default class ExtraccionesUltimoMesChart extends React.Component<{}, IExtraccionesUltimoMesChartState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            data: [],
            month: new Date().getMonth() + 1,
            loading: true
        }
    }

    componentDidMount(): void {
        this.Get(new Date().getMonth() + 1);
    }

    public render(): React.ReactElement<{}> {
        return (
            <Card>
                <CardContent>
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <Typography variant="h5" component="div">
                            Extracciones por mes
                        </Typography>
                        <FormControl style={{width: '200px'}} variant="standard">
                            <Select label="Seleccione un mes" value={this.state.month.toString()} labelId='labelMeses' onChange={(event: SelectChangeEvent) => {
                                this.Get(Number(event.target.value));
                            }}>
                                <MenuItem value={1}>Enero</MenuItem>
                                <MenuItem value={2}>Febrero</MenuItem>
                                <MenuItem value={3}>Marzo</MenuItem>
                                <MenuItem value={4}>Abril</MenuItem>
                                <MenuItem value={5}>Mayo</MenuItem>
                                <MenuItem value={6}>Junio</MenuItem>
                                <MenuItem value={7}>Julio</MenuItem>
                                <MenuItem value={8}>Agosto</MenuItem>
                                <MenuItem value={9}>Septiembre</MenuItem>
                                <MenuItem value={10}>Octubre</MenuItem>
                                <MenuItem value={11}>Noviembre</MenuItem>
                                <MenuItem value={12}>Diciembre</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                    {
                        !this.state.loading && this.state.data.length > 0 && (
                            <LineChart
                                dataset={this.state.data}
                                xAxis={[{ scaleType: 'point', dataKey: 'date' }]}
                                series={[
                                    { dataKey: 'total', label: 'Extracciones', color: Common.MAN_BORDER_COLOR }
                                ]}
                                height={350}
                                margin={{
                                    bottom: 100
                                }}
                                slotProps={
                                    {
                                        legend: {
                                            direction: 'row',
                                            position: {
                                                vertical: 'bottom',
                                                horizontal: 'right',
                                            },
                                            itemMarkWidth: 20,
                                            itemMarkHeight: 6,
                                            markGap: 5,
                                            itemGap: 10,
                                            labelStyle: {
                                                fontSize: 11
                                            }
                                        }
                                    }
                                }
                            />
                        )
                    }
                    {
                        this.state.data.length == 0 && (
                            <Alert severity='info' style={{margin: '97px 0px', padding: '60px 20px'}}>
                                No hay extracciones para el mes seleccionado.
                            </Alert>
                        )
                    }
                </CardContent>
            </Card>
        )
    }

    private Get(month: number) {
        let url = `${Common.END_POINT}/extracciones/month/${month}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            const data: any[] = [];

            for(let i = 0; i < response.length; i++) {
                const dataItem: any = {};
                dataItem.date = new Date(response[i].date).toLocaleDateString();
                dataItem.total = response[i].total;

                data.push(dataItem);
            }
            
            this.setState({
                data: data,
                month: month,
                loading: false
            })
        })
    }
}